import axios from 'axios';
const contactEndpoint = '/notification/contact';

export const sendContact = async (data) => {
  const response = await axios.post(contactEndpoint, data);
  return response.data;
};
